// extracted by css-extract-rspack-plugin
export default {"eventsFilters":"events-filters--uCbbdir19bIkpmwg","eventsSelect":"events-select--FvApziLzR1AnZyPh"};